export default "__VITE_ASSET__BgOGLrNZ__"